import React, { useEffect } from "react"
import { useParams } from "react-router"

function ProductInfo ({
    
}) {
    
    const { id } = useParams()

    useEffect(() => {
        loadDetailProduct()
    }, [])

    const loadDetailProduct = async () => {
        console.log(id)
        // let { data, error } = await getPODetail({ _id: id })
        // console.log(data)
    }

    return (
        <div>Hello World</div>
    )
}

export default ProductInfo